export const mobileFilters = [
  {
    name: 'SalesOverview',
    headers: ['Period'],
  },
  {
    name: 'SalesAndPaymentsPerCategory',
    headers: ['Kategori'],
  },
  {
    name: 'SalesPerDate',
    headers: ['Datum'],
  },
  {
    name: 'SalesPerCategory',
    headers: ['Kategori'],
  },
  {
    name: 'SalesPerSupplier',
    headers: ['Leverantör'],
  },
  {
    name: 'SalesPerCampaign',
    headers: ['Produkt', 'Kampanj'],
  },
  {
    name: 'SalesPerCategoryAndEmployee',
    headers: ['Anställd', 'Kategori'],
  },
  {
    name: 'SalesPerCategoryAndCustomer',
    headers: ['Kund', 'Kategori'],
  },
  {
    name: 'SalesPerSupplierAndProduct',
    headers: ['Produkt', 'Kategori'],
  },
  {
    name: 'SalesPerProduct',
    headers: ['Produkt', 'Kategori'],
  },
  {
    name: 'Transactions',
    headers: ['EnteredByEmployeeName', 'Number'],
  },
];